import React, { useState, useEffect } from "react";
import api from "../services/apiService";
import { CHAT_BOTS, CHAT_SESSIONS, CHAT_TALK } from "../services/apiRoutes";

export async function getBots() {
  // GET /chat/bots/
  const response = await api.get(CHAT_BOTS);
  return response.data;
}

export async function createBot(name, instructions) {
  // POST /chat/bots/
  const response = await api.post(CHAT_BOTS, {
    name,
    instructions,
  });
  return response.data;
}

export async function startSession(botId) {
  // POST /chat/sessions/
  const response = await api.post(CHAT_SESSIONS, {
    bot_id: botId,
  });
  return response.data;
}

export async function sendMessageToSession(sessionId, message) {
  // POST /chat/talk/
  const response = await api.post(CHAT_TALK, {
    session_id: sessionId,
    message,
  });
  return response.data;
}

function ChatPage() {
  // State for bots and chat session
  const [bots, setBots] = useState([]);
  const [createMode, setCreateMode] = useState(false);
  const [botName, setBotName] = useState("");
  const [botInstructions, setBotInstructions] = useState("");

  const [sessionId, setSessionId] = useState(null);
  const [messages, setMessages] = useState([]);
  const [messageInput, setMessageInput] = useState("");

  // On mount, load the available bots
  useEffect(() => {
    loadBots();
  }, []);

  const loadBots = async () => {
    try {
      const data = await getBots();
      setBots(data.bots || []);
    } catch (error) {
      alert("Error loading bots");
    }
  };

  const handleCreateBot = async () => {
    if (!botName.trim() || !botInstructions.trim()) {
      alert("Please fill in both bot name and instructions");
      return;
    }
    try {
      const data = await createBot(botName.trim(), botInstructions.trim());
      if (data.status === "Bot created successfully!") {
        alert("Bot created");
        setBotName("");
        setBotInstructions("");
        setCreateMode(false);
        loadBots();
      } else {
        alert("Error creating bot");
      }
    } catch (err) {
      alert("Error creating bot");
    }
  };

  const handleStartSession = async (botId) => {
    try {
      const data = await startSession(botId);
      if (data.session_id) {
        setSessionId(data.session_id);
        setMessages([]);
      } else {
        alert("Failed to start session");
      }
    } catch (err) {
      alert("Error starting session");
    }
  };

  const handleSendMessage = async () => {
    if (!messageInput.trim()) return;
    // Optimistically add the user's message
    setMessages((prev) => [...prev, { sender: "You", text: messageInput }]);
    try {
      const data = await sendMessageToSession(sessionId, messageInput.trim());
      if (data.response) {
        setMessages((prev) => [
          ...prev,
          { sender: "Bot", text: data.response },
        ]);
      } else {
        alert("No response from bot");
      }
    } catch (err) {
      alert("Error sending message");
    }
    setMessageInput("");
  };

  return (
    <div className="chat-container">
      <div className="left-column">
        <button onClick={() => setCreateMode(!createMode)}>Create Bot</button>
        {createMode && (
          <div className="create-form">
            <h3>Create Bot</h3>
            <input
              type="text"
              placeholder="Bot Name"
              value={botName}
              onChange={(e) => setBotName(e.target.value)}
            />
            <textarea
              placeholder="Bot Instructions"
              value={botInstructions}
              onChange={(e) => setBotInstructions(e.target.value)}
            />
            <button onClick={handleCreateBot}>Submit</button>
          </div>
        )}
      </div>

      <div className="right-column">
        <h3>Bots</h3>
        <div className="bot-list">
          {bots.map((bot) => (
            <div key={bot.id} onClick={() => handleStartSession(bot.id)}>
              {bot.name}
            </div>
          ))}
        </div>

        {sessionId && (
          <div className="chat-interface">
            <div className="messages">
              {messages.map((msg, i) => (
                <div key={i} className={msg.sender.toLowerCase()}>
                  <strong>{msg.sender}:</strong> {msg.text}
                </div>
              ))}
            </div>
            <input
              type="text"
              placeholder="Type your message..."
              value={messageInput}
              onChange={(e) => setMessageInput(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") handleSendMessage();
              }}
            />
            <button onClick={handleSendMessage}>Send</button>
          </div>
        )}
      </div>
    </div>
  );
}

export default ChatPage;
